import { MAT_DATE_LOCALE, MatPaginatorIntl, MatPaginatorModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, registerLocaleData } from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AlertModule } from 'ngx-alerts';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BlankComponent } from './layouts/blank/blank.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { FullComponent } from './layouts/full/full.component';
import { HeaderComponent } from './layouts/header/header.component';

import { NavigationComponent } from './shared/header-navigation/navigation.component';
import { MatPaginatorIntlSpanish } from './shared/MatPaginatorIntlSpanish.component';
import { Client, API_BASE_URL } from './shared/services/client';
import { SharedModule } from './shared/shared.module';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AuthenticationService } from './shared/services/authentication.service';
import { TokenInterceptor } from './shared/services/token-interceptor.service';
import { Approutes } from './app-routing.module';
import { AppComponent } from './app.component';
import { SpinnerComponent } from './shared/spinner.component';
import localeDo from '@angular/common/locales/es-DO';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ConfigAccessCheckService } from './shared/services/config-access-check.service';
import { AdminAccessCheckService } from './shared/services/admin-access-check.service';
import { urls } from '../assets/constants.json';

registerLocaleData(localeDo, 'es-DO');

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	suppressScrollX: true,
	wheelSpeed: 2,
	wheelPropagation: true
};

@NgModule({
	declarations: [
		AppComponent,
		SpinnerComponent,
		BlankComponent,
		FullComponent,
		NavigationComponent,
		BreadcrumbComponent,
		SidebarComponent,
		HeaderComponent,
		FooterComponent
	],
	imports: [
		CommonModule,
		BrowserModule,
		BrowserAnimationsModule,
		FormsModule,
		SharedModule,
		HttpClientModule,
		MatPaginatorModule,
		NgbModule.forRoot(),
		RouterModule.forRoot(Approutes),
		PerfectScrollbarModule,
		NgxSpinnerModule,
		AlertModule.forRoot({ maxMessages: 5, timeout: 30000, position: 'right' })
	],
	providers: [
		Client,
		AuthenticationService,
		AdminAccessCheckService,
		ConfigAccessCheckService,
		{ provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
		{
			provide: PERFECT_SCROLLBAR_CONFIG,
			useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
		},
		{ provide: MatPaginatorIntl, useClass: MatPaginatorIntlSpanish },
		{ provide: LOCALE_ID, useValue: 'es-DO' },
		{ provide: MAT_DATE_LOCALE, useValue: 'es-DO' },
		{ provide: API_BASE_URL, useValue: urls.apiBaseUrl }
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
